import React, { Component } from "react";
import Table from "../common/table";
import { Link } from "react-router-dom";
import { Icon, Button, Label, Grid } from "semantic-ui-react";
import Currency from "../common/currency";
import Actions from "../common/actions";

class SupplierItemsTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      width: "2",
    },
    {
      path: "code",
      label: "Code",
      width: "2",
    },
    {
      path: "category_id",
      label: "Category",
      width: "2",
      content: (item) => item.category.name,
    },
    { path: "stock", label: "Stock", width: "1" },
    { path: "threshold", label: "Threshold", width: "1" },
    {
      key: "actions",
      width: "2",
      content: (item) => (
        <div>
          {/* <Icon
            name={item.status == 1 ? "hide" : "eye"}
            color={item.status == 1 ? "black" : "green"}
            className="clickable"
            onClick={() => this.props.onStatusUpdate(item)}
          /> */}
          <Icon
            name="trash"
            color="red"
            className="clickable"
            onClick={() => this.props.onDelete(item)}
          />

          <Icon
            name="edit"
            color="blue"
            className="clickable"
            onClick={() => this.props.onUpdate(item)}
          />
        </div>
      ),
    },
  ];

  render() {
    const { items, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={items}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default SupplierItemsTable;
